import { React } from "react";
import { Row, Col, Select } from "antd";
import { DeliveryBox } from "@UI";
import "./index.scss";
import CheckedImg from "./img/checked.svg";
import DebtDashboardCard from "./debt-dashboard-card";
import { FiPackage, FiTruck, FiArrowUpRight } from "react-icons/fi";
import { BsPatchCheck, BsShop, BsHourglass } from "react-icons/bs";
import { MdOutlinePedalBike } from "react-icons/md";
import { BiArchiveIn } from "react-icons/bi";

const MainSlider = ({
  data,
  visibleBoxes,
  selectedMerchant,
  info,
  setChannel,
  channel,
  channelList,
}) => {
  const statusCardHover = {
    backgroundColor: "rgba(0, 0, 0, 0.018)",
    borderColor: "#e0e0e0",
  };

  const toBeTakenData = {
    value: data?.toBeTaken,
    text: "Teslim Alınacaklar",
    textColor: "whiteSmoke",
    color: "#7723db",
    hover: {
      backgroundColor: "#9250E3",
      borderColor: "transparent",
    },
    status: "toBeTaken",
    icon: (
      <div
        style={{
          marginBottom: "14px",
        }}
      >
        <BiArchiveIn size={36} />
      </div>
    ),
  };

  const deliveredData = {
    value: data?.delivered,
    text: "Teslim Edilenler",
    textColor: "whiteSmoke",
    color: "#189B18",
    hover: {
      backgroundColor: "#20AD20",
      borderColor: "transparent",
    },
    bgImg: CheckedImg,
    status: "delivered",
    icon: (
      <div
        style={{
          marginBottom: "14px",
        }}
      >
        <BsPatchCheck size={36} />
      </div>
    ),
  };
  const deliveryBranchData = {
    value: data?.deliveryBranch,
    text: "Teslimat Şubesinde",
    hover: statusCardHover,
    status: "deliveryBranch",
    icon: (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "48px",
          height: "48px",
          backgroundColor: "#E6F0FF", // Açık Mavi
          borderRadius: "50%",
          marginBottom: "16px",
        }}
      >
        <BsShop size={24} style={{ color: "#3B82F6" }} />
      </div>
    ),
  };
  const acceptedData = {
    value: data?.received,
    text: "Alınan Gönderiler",
    hover: statusCardHover,
    status: "received",
    icon: (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "48px",
          height: "48px",
          backgroundColor: "#F3EBFF", // Açık Mor
          borderRadius: "50%",
          marginBottom: "16px",
        }}
      >
        <FiPackage size={32} style={{ color: "#7723db" }} />
      </div>
    ),
  };
  const returnedData = {
    value: data?.returned,
    text: "İade Edilenler",
    hover: statusCardHover,
    status: "returned",
    icon: (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "48px",
          height: "48px",
          backgroundColor: "#FFEBEB", // Açık Kırmızı
          borderRadius: "50%",
          marginBottom: "16px",
        }}
      >
        <FiArrowUpRight size={24} style={{ color: "#EF4444" }} />
      </div>
    ),
  };

  const returningData = {
    value: data?.returning,
    text: "İade Sürecinde",
    hover: statusCardHover,
    status: "returning",
    icon: (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "48px",
          height: "48px",
          backgroundColor: "#EBF3FF", // Açık Mavi
          borderRadius: "50%",
          marginBottom: "16px",
        }}
      >
        <BsHourglass size={24} style={{ color: "#3B82F6" }} />
      </div>
    ),
  };

  const transferringData = {
    value: data?.transferring,
    text: "Transfer Sürecinde",
    hover: statusCardHover,
    status: "transferring",
    icon: (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "48px",
          height: "48px",
          backgroundColor: "#FFF0E6", // Açık Turuncu
          borderRadius: "50%",
          marginBottom: "16px",
        }}
      >
        <FiTruck size={24} style={{ color: "#FF6B00" }} />
      </div>
    ),
  };

  const deliveringData = {
    value: data?.delivering,
    text: "Kurye Dağıtıma Çıktı",
    hover: statusCardHover,
    status: "delivering",
    icon: (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "48px",
          height: "48px",
          backgroundColor: "#EBFFEB", // Açık Yeşil
          borderRadius: "50%",
          marginBottom: "16px",
        }}
      >
        <MdOutlinePedalBike size={24} style={{ color: "#22C55E" }} />
      </div>
    ),
  };
  const invoiceDashboard =
    info?.invoiceEnabled &&
    info?.authorities?.includes("INVOICE_DASHBOARD");
  const deliverySpan = 8;
  return (
    <>
      <Row className="hero-img-text">
        <Col span={24}>
          <h1>JetPartner'e Hoş Geldiniz!</h1>
        </Col>
        <Col span={4}>
          <Select
            placeholder="Kanallar"
            onChange={(e) => {
              sessionStorage.setItem("channel", e);
              setChannel(e);
            }}
            disabled={info?.onlyJetpartnerDeliveries}
            value={channel}
            options={channelList}
            style={{ width: "100%" }}
          />
        </Col>
      </Row>
      <Row gutter={16} className="carrier" style={{ marginTop: 16 }}>
        <Col className="gutter-row" span={invoiceDashboard ? 16 : 24}>
          <Row gutter={16}>
            <Col span={12}>
              <DeliveryBox
                data={toBeTakenData}
                selectedMerchant={selectedMerchant}
              />
            </Col>
            <Col span={12}>
              <DeliveryBox
                data={deliveredData}
                selectedMerchant={selectedMerchant}
              />
            </Col>
            <Col className="gutter-row" span={deliverySpan}>
              <DeliveryBox
                data={acceptedData}
                selectedMerchant={selectedMerchant}
              />
            </Col>
            <Col className="gutter-row" span={deliverySpan}>
              <DeliveryBox
                data={transferringData}
                selectedMerchant={selectedMerchant}
              />
            </Col>

            <Col className="gutter-row" span={deliverySpan}>
              <DeliveryBox
                data={deliveryBranchData}
                selectedMerchant={selectedMerchant}
              />
            </Col>

            <Col className="gutter-row" span={deliverySpan}>
              <DeliveryBox
                data={deliveringData}
                selectedMerchant={selectedMerchant}
              />
            </Col>

            <Col className="gutter-row" span={deliverySpan}>
              <DeliveryBox
                data={returnedData}
                selectedMerchant={selectedMerchant}
              />
            </Col>
            <Col className="gutter-row" span={deliverySpan}>
              <DeliveryBox
                data={returningData}
                selectedMerchant={selectedMerchant}
              />
            </Col>
          </Row>
        </Col>

        {invoiceDashboard && (
          <Col className="gutter-row" span={8}>
            <DebtDashboardCard />
          </Col>
        )}
      </Row>
    </>
  );
};
export default MainSlider;
